import React, { useEffect, useState, useRef } from "react";
import Styles from "./FormWrapper.module.css";

const FormWrapper = ({ formSteps, data, onSubmit }) => {
  const [currentStep, setCurrentStep] = useState(0);
  const [currentDisplayIndex, setCurrentDisplayIndex] = useState(1);
  const [formData, setFormData] = useState(data);
  const validateForm = useState({ current: () => true })[0];
  const onNext = useState({ current: () => null })[0];
  const onBack = useState({ current: () => null })[0];
  const scrollToRef = useRef(null);

  const formStepsToArray = () => {
    const stepsObj = formSteps(formData)
    return Object.entries(stepsObj).map(([key, value]) => value).filter(value => value != null)
  }
  const [steps, setSteps] = useState(formStepsToArray())

  const handleScroll = (offset) => {
    const currentScrollPos = window.scrollY;
    const targetPosition = scrollToRef.current.getBoundingClientRect().top + currentScrollPos;

    if (currentScrollPos > targetPosition - offset) {
      window.scrollTo({
        top: targetPosition - offset,
        behavior: "smooth",
      });
    }
  };

  const handleNext = async () => {
    if ((await validateForm.current(formData)) && currentStep < steps.length - 1) {
      const tempSteps = formStepsToArray()
      setCurrentDisplayIndex(tempSteps[currentStep + 1].displayIndex || tempSteps[currentStep + 1].parentIndex)
      setCurrentStep((prev) => prev + 1);
      validateForm.current = () => true;
      onNext.current();
      onNext.current = () => null;
      setSteps(tempSteps)
    }
  };

  const handleSubmit = () => {
    if (validateForm.current(formData)) {
      if (onSubmit) onSubmit(formData);
      if (currentStep < steps.length - 1) setCurrentStep((prev) => prev + 1);
    }
  };

  const handleBack = () => {
    if (currentStep > 0 || onBack.current()) {
      const tempSteps = formStepsToArray()
      setCurrentDisplayIndex(tempSteps[currentStep - 1].displayIndex || tempSteps[currentStep - 1].parentIndex)
      setCurrentStep((prev) => prev - 1);
      onBack.current = () => null;
      setSteps(tempSteps)
    }
  };

  const handleInputChange = (field, value, parentField) => {
    setFormData((prev) => {
      if (!parentField) {
        return {
          ...prev,
          [field]: value,
        };
      }

      return {
        ...prev,
        [parentField]: {
          ...prev[parentField],
          [field]: value,
        },
      };
    });
  };

  const StepComponent = steps[currentStep].component;

  useEffect(() => {
    if (
      steps[currentStep].scrollToTop == null ||
      steps[currentStep].scrollToTop
    )
      handleScroll(160);
  }, [currentStep]);

  return (
    <>
      <div className={Styles.container} ref={scrollToRef}>
        <div className={Styles.breadCrumb}>
          {steps.filter(step => step.displayIndex !=  null).map(
            (step) =>
              step.title && (
                <React.Fragment key={step?.displayIndex}>
                  <div
                    className={`${Styles.step} ${
                      step.displayIndex === currentDisplayIndex
                        ? Styles.currentStep
                        : Styles.hiddenStep
                    }`}
                    key={step.displayIndex}
                  >
                    {step.displayIndex}
                    <div className={Styles.stepTitle}>. {step.title}</div>
                  </div>
                  {!step.isLast && " > "}
                </React.Fragment>
              )
          )}
        </div>
        <div className={Styles.formContainer}>
          <div className={Styles.fieldContainer}>
            <StepComponent
              {...steps[currentStep].component.props}
              formData={formData}
              handleInputChange={handleInputChange}
              validateForm={validateForm}
              onNext={onNext}
              onBack={onBack}
            />
          </div>

          <hr style={{ margin: 0 }} />

          <div className={Styles.buttonContainer}>
            <button
              className="btn btn-secondary text-dark btn-sm m-1"
              style={{ borderColor: "gray" }}
              onClick={handleBack}
            >
              BACK
            </button>
            {currentStep < steps.length - 1 ? (
              <button
                className="btn btn-primary-grad btn-sm m-1 right"
                onClick={handleNext}
              >
                NEXT
              </button>
            ) : (
              <button
                className="btn btn-primary-grad btn-sm m-1"
                onClick={handleSubmit}
              >
                SUBMIT
              </button>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default FormWrapper;
